import React, { Component } from 'react';
import { auth } from '../firebase';

export default class Login extends Component {
  constructor (props) {
    super(props);

    this.state = {
    };
  }

  componentWillMount () {

    auth.onAuthStateChanged((user) => {
      auth.signOut().then(()=>{
        console.log("ログアウトしました");
        //scope.props.history.push("/signup");
      })
      .catch( (error)=>{
        console.log(`ログアウト時にエラーが発生しました (${error})`);
      });
    });
  }

  render () {
    return (
   	<div className="sp home">
      読み込み中
    </div>
    );
  }
}